import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setClusterMinMaxMetric as setClusterMinMaxMetricDiagram, getClusterMinMaxMetric as getClusterMinMaxMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setClusterMinMaxMetric = ({
    min,
    max,
}: MinMaxProps) => {
    setClusterMinMaxMetricDiagram({min, max});
    apiProvider.updateDiagramCluster({source : 'setClusterMinMaxMetric'});
};


export const getClusterMinMaxMetric = (): MinMaxProps => getClusterMinMaxMetricDiagram();
